// @generated by protoc-gen-es v2.10.0 with parameter "target=ts"
// @generated from file message/message_encrypted_model.proto (package com.gem.bff.contract, syntax proto3)

/* eslint-disable */
import type { Message } from '@bufbuild/protobuf';
import type { GenFile, GenMessage } from '@bufbuild/protobuf/codegenv2';
import { fileDesc, messageDesc } from '@bufbuild/protobuf/codegenv2';

/**
 * Describes the file message/message_encrypted_model.proto.
 */
export const file_message_message_encrypted_model: GenFile =
  /*@__PURE__*/
  fileDesc(
    'CiVtZXNzYWdlL21lc3NhZ2VfZW5jcnlwdGVkX21vZGVsLnByb3RvEhRjb20uZ2VtLmJmZi5jb250cmFjdCKOAQobRW5jcnlwdGVkTWVzc2FnZVBheWxvYWREYXRhEkoKBHRleHQYASABKAsyOi5jb20uZ2VtLmJmZi5jb250cmFjdC5FbmNyeXB0ZWRNZXNzYWdlUGF5bG9hZERhdGEuVGV4dERhdGFIABoYCghUZXh0RGF0YRIMCgR0ZXh0GAEgASgJQgkKB3BheWxvYWRCGAoUY29tLmdlbS5iZmYuY29udHJhY3RQAWIGcHJvdG8z'
  );

/**
 * @generated from message com.gem.bff.contract.EncryptedMessagePayloadData
 */
export type EncryptedMessagePayloadData =
  Message<'com.gem.bff.contract.EncryptedMessagePayloadData'> & {
    /**
     * @generated from oneof com.gem.bff.contract.EncryptedMessagePayloadData.payload
     */
    payload:
      | {
          /**
           * @generated from field: com.gem.bff.contract.EncryptedMessagePayloadData.TextData text = 1;
           */
          value: EncryptedMessagePayloadData_TextData;
          case: 'text';
        }
      | { case: undefined; value?: undefined };
  };

/**
 * Describes the message com.gem.bff.contract.EncryptedMessagePayloadData.
 * Use `create(EncryptedMessagePayloadDataSchema)` to create a new message.
 */
export const EncryptedMessagePayloadDataSchema: GenMessage<EncryptedMessagePayloadData> =
  /*@__PURE__*/
  messageDesc(file_message_message_encrypted_model, 0);

/**
 * @generated from message com.gem.bff.contract.EncryptedMessagePayloadData.TextData
 */
export type EncryptedMessagePayloadData_TextData =
  Message<'com.gem.bff.contract.EncryptedMessagePayloadData.TextData'> & {
    /**
     * @generated from field: string text = 1;
     */
    text: string;
  };

/**
 * Describes the message com.gem.bff.contract.EncryptedMessagePayloadData.TextData.
 * Use `create(EncryptedMessagePayloadData_TextDataSchema)` to create a new message.
 */
export const EncryptedMessagePayloadData_TextDataSchema: GenMessage<EncryptedMessagePayloadData_TextData> =
  /*@__PURE__*/
  messageDesc(file_message_message_encrypted_model, 0, 0);
